import { DefaultRenderPathResolver } from '../DefaultRenderPathResolver.js';
import { CanvasECGPath } from './CanvasECGRenderPath.js';
export function createDefaultECGRenderPaths() {
    return [new CanvasECGPath()];
}
export function createECGRenderPathResolver(paths = createDefaultECGRenderPaths()) {
    return new DefaultRenderPathResolver(paths);
}
